// extracted by mini-css-extract-plugin
export default {"scrollWrapper":"styles_scrollWrapper__oR8nO","search":"styles_search__0CWKD"};